import { Component, OnInit, ViewChild, Input, AfterViewInit } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { UserApiService } from 'src/app/user-api.service';



@Component({
  selector: 'app-facture-list',
  templateUrl: './facture-list.component.html',
  styleUrls: ['./facture-list.component.scss']
})
export class FactureListComponent implements OnInit , AfterViewInit  {

  constructor( private userApiService: UserApiService,){}


  
  public nextLoaded : boolean = false;
  dataSource = new MatTableDataSource<Facture>();


  displayedColumns: string[] = ['datefa', 'motif', 'tarif'];

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    // this.nextLoaded = true;
}

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  
 

  ngOnInit() {
   
    this.SubscribeFactureUser()

  }
  
  
  
    startdate = new Date('2011-01-01T00:00:00Z');
    enddate = new Date()
     SubscribeFactureUser(){
       this.userApiService.getFactureUser(this.startdate, this.enddate)
       .subscribe( res => {this.dataSource.data = res.data.list.sort((a,b) =>  new Date(b.date).getTime() - new Date(a.date).getTime());
        
        
      } )
     }

  
}


export interface Facture {
  date: string;
  amount: number;
  type: number;
  comment: string;
}

